import React from 'react'
import I18n from 'APP/I18n'
import Button from 'APP/Converse/Button'
import Typography from 'APP/Converse/Typography'
import styled from 'styled-components/native'
import Color from 'color'

import { View } from 'react-native'

const StyledCard = styled.View`
  flex: 1;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin};
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 2};
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.5};
  border-radius: 20;
  ${({ theme }) => theme.shadows.soft};
`

const StyledCardOutline = styled(View)`
  align-items: center;
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin};
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 2};
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.5};
  border-radius: 20;
  border-width: 3;
  border-style: dashed;
  border-color: ${({ theme }) =>
    Color(theme.colors.buttonSecondaryDisabled).alpha(0.3).rgb().string()};
`

const StyledTitle = styled(Typography).attrs(() => ({
  variant: 'subheaderBold',
}))`
  color: ${({ theme }) => theme.colors.text};
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin};
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 0.5};
`

const StyledCopy = styled(Typography).attrs(() => ({
  variant: 'bodyNormal',
}))`
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin * 0.5};
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin};
`

const NoHabitsForPastDay = () => (
  <StyledCard testID="NO_HABITS_CARD">
    <StyledTitle>{I18n.t('Habits.noHabits.pastDayTitle')}</StyledTitle>
    <StyledCopy>{I18n.t('Habits.noHabits.pastDayCopy')}</StyledCopy>
  </StyledCard>
)

const NoHabitsForToday = ({ onAddHabitPress }) => (
  <StyledCardOutline testID="NO_HABITS_CARD_OUTLINE">
    <StyledCopy>{I18n.t('Habits.noHabits.copy')}</StyledCopy>
    <Button
      variant="oomph"
      title={I18n.t('Habits.noHabits.cta')}
      onPress={onAddHabitPress}
      analyticsName="noHabits.add"
    />
  </StyledCardOutline>
)

const NoHabitsCard = ({ isToday, onAddHabitPress }) => {
  const Component = isToday ? NoHabitsForToday : NoHabitsForPastDay
  return <Component onAddHabitPress={onAddHabitPress} />
}

export default NoHabitsCard
